import traceMixin from '@/mixins/traceMixin'
export class TracePlugin {
  static install(Vue, _options) {
    if (process.env.VUE_APP_TRACING === 'true') {
      Vue.mixin(traceMixin)
    }
  }
}
